import { qaBackendApiInstance } from "@src/config/config"

export async function getHdAssets(assets:any){
    const token = localStorage.getItem('accessToken')
    
    const postBody={
      data:assets,
    //   domian_id:
    }
    let attempts = 0
    const maxAttempts = 3

    while (attempts < maxAttempts) {
      try {
        const response = await qaBackendApiInstance.post('/video/gen-premium-assets',
          postBody,
          {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    
      )
      return response.data
      } catch (error: any) {
        attempts++
        // Retry on 500 or network error
        const is500 = error?.response && error.response.status === 500
        const isNetwork = !error.response && (error.code === 'ERR_NETWORK' || error.message === 'Network Error')
        if ((is500 || isNetwork) && attempts < maxAttempts) {
          await new Promise(res => setTimeout(res, 500))
          continue
        }
        // For other errors or after max attempts, return -1
        return -1
      }
    }
    return -1
  }